import {
    AdditionalFeesAllowed, LaneFeesAllowed, OtherFeesAllowed, LongTermLeaseFeesAllowed,
} from 'app/enums/label.enums'

import {
    FeesType,
} from 'app/enums/common.enums'

export const feeNames: Record<FeesType, Record<string, string>> = {
    [FeesType.Lane]: LaneFeesAllowed,
    [FeesType.Additional]: AdditionalFeesAllowed,
    [FeesType.OtherFees]: OtherFeesAllowed,
    [FeesType.LongTermLease]: LongTermLeaseFeesAllowed,
}

export const feeChargeabilityWithoutValues = [
    'NOT_APPLICABLE',
    'INCLUDED',
    'PERCENTAGE_BASE_LEASE_PERIOD',
    'PERCENTAGE_BASE_LEASE_POSITIONING_PERIOD',
    'TBD',
    'UNSPECIFIED',
]

export const CHARGEABILITIES_WITH_PRODUCT_TYPE = [
    'FIXED_AMOUNT_PER_DAY_CONTAINER',
    'FIXED_AMOUNT_CONTAINER_SPECIFIC',
    'PER_CONTAINER_PER_MONTH',
    'PER_CONTAINER_PER_SHIPMENT',
    'PER_CONTAINER_PER_ADDL_SHIPMENT',
    'CONTAINER_SPECIFIC_PER_REQUIREMENT',
]
